import { defineComponent as _defineComponent } from 'vue';
import { vShow as _vShow, normalizeClass as _normalizeClass, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8f21d388"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _createTextVNode("This site uses charts from ");
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    href: "https://www.tradingview.com/",
    target: "_blank"
}, "TradingView", -1));
const _hoisted_3 = [
    _hoisted_1,
    _hoisted_2
];
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import { useStore } from '@/store/store';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        title: null,
        fullscreen: { type: Boolean, default: false },
        help: { type: Boolean }
    },
    emits: ["changeFull"],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const isFull = ref(store.getters.chartIsFull);
        const onFullScreenClick = () => {
            isFull.value = !isFull.value;
            emit('changeFull', isFull.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _withDirectives(_createVNode(MaterialIcon, {
                    name: !isFull.value ? 'open_in_full' : 'close_fullscreen',
                    class: _normalizeClass(["fullscreen", !isFull.value ? 'zoom-in' : 'zoom-out']),
                    onClick: onFullScreenClick
                }, null, 8, ["name", "class"]), [
                    [_vShow, props.fullscreen]
                ]),
                _createElementVNode("div", {
                    class: _normalizeClass(["title", isFull.value && 'full_title'])
                }, [
                    _withDirectives(_createElementVNode("span", null, _toDisplayString(props.title), 513), [
                        [_vShow, props.title]
                    ]),
                    _withDirectives(_createElementVNode("span", null, _hoisted_3, 512), [
                        [_vShow, props.help]
                    ])
                ], 2)
            ], 64));
        };
    }
});
